module.exports = __webpack_public_path__ + "img/person-4.52a9599.webp";